import './Section.scss';

import React, { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Header } from './Header/Header';
import { Footer } from './Footer/Footer';
import { SectionTypes } from './SectionTypes';
import { createSubtitle } from './utils/createSubtitle';
import { createCollapsedSubtitle } from './utils/createCollapsedSubtitle';
import { useSectionScroll } from './hooks/useSectionScroll';
import { doTagCurrentSection, doTagCurrentSectionButton, doTagCurrentSectionEdit } from './tagging';
import UtagHelper from 'utilities/utagHelper';
import cryptoJS from 'crypto-js';
import { setPageName } from 'actions/errorViewNavigation';

const SectionComponent = ({
    children,
    type,
    isCollapsed,
    isValidated,
    handleModifySection,
    handleValidateSection,
    isButtonDisabled,
    hideFooter,
    promoCode,
    userProfile,
    setPageName,
}) => {
    const { className, icon, editIcon, editText, title, buttonText } = SectionTypes[type];
    const sectionRef = useSectionScroll(isCollapsed);
    const collapsedClass = isCollapsed && 'initial-section__content--collapsed';
    const sectionClass = `initial-section__content ${collapsedClass}`;
    const jointHolderInfo = useMemo(
        () => UtagHelper.getJointHolderInfoFromUserProfile(userProfile),
        [userProfile.jointHolderType, userProfile.isJointHolderAccount, userProfile.isJointHolderNoClient]
    );

    useEffect(() => {
        userProfile.investmentType &&
            setPageName(
                doTagCurrentSection({
                    type,
                    isCollapsed,
                    promoCode,
                    jointHolderInfo,
                    investmentType: userProfile.investmentType,
                    identificadorOnboarding: userProfile.docNumber
                        ? cryptoJS.SHA256(userProfile.docNumber).toString()
                        : '',
                    userId: userProfile.userId,
                })
            );
    }, [type, isCollapsed, promoCode, jointHolderInfo, userProfile.investmentType]);

    const handleClickNextSection = () => {
        handleValidateSection();
        doTagCurrentSectionButton(type);
    };

    const handleEditSection = () => {
        handleModifySection();
        doTagCurrentSectionEdit(type);
    };

    return (
        <div ref={sectionRef} className={`intial-section ${className} basic-layering`} data-testid={type}>
            <Header
                isCollapsed={isCollapsed}
                isValidated={isValidated}
                editIcon={editIcon}
                editText={editText}
                title={title}
                subtitle={createSubtitle(type)}
                collapsedSubtitle={createCollapsedSubtitle(type, userProfile)}
                icon={icon}
                editAction={handleEditSection}
            />
            <div data-testid="collapsable-content" className={sectionClass}>
                {children}
            </div>
            <Footer
                buttonText={buttonText}
                isHidden={isCollapsed || hideFooter}
                onClickButton={handleClickNextSection}
                isButtonDisabled={isButtonDisabled}
            />
        </div>
    );
};

const mapDispatchToProps = dispatch => ({
    setPageName: bindActionCreators(setPageName, dispatch),
});

export const Section = connect(null, mapDispatchToProps)(SectionComponent);
